import { Game as GameComponent } from './Game/Game';

export const Game: React.FC = () => {
  return <GameComponent />;
};